export default "__VITE_ASSET__Biig__SC__"